import React from 'react';
import FeatureCards from "../../../../components/FeatureCards/FeatureCards";
import CTA from "../../../../components/Constant/cta/CTA";
import TimelineSection from "../../../../components/TimelineSection/TimelineSection";
import WhySection from "../../../../components/WhySection/WhySection";
import LocationTimeline from "../../../../components/LocationTimeline/LocationTimeline";
import IntroSection from "../../../../components/IntroSection/IntroSection";
import FAQList from "../../../../components/Constant/FAQCard/FAQCard";
import Testimonials from "../../../../components/Constant/Testimonials/Testimonials";
import DetailsSection from "../../../../components/DetailsSection/DetailsSection";
import InfoBlocks from "../../../../components/InfoBlocks/InfoBlocks";
import ServiceCards from "../../../../components/ServiceCards/ServiceCards";
import SEO from "../../../../utils/SEO";

export default function CryptoBlockchainLicenseCyprus() {

    return (
        <main className='main'>
            <SEO
                title="Cyprus Funds License | AIF & Asset Management EU "
                description="Set up funds and asset management firms in Cyprus. AIF, UCITS & PIF structures with CySEC regulation and EU passporting across the EEA. "
                keywords="Cyprus funds license, AIF Cyprus, UCITS Cyprus, PIF Cyprus, asset management Cyprus, CySEC fund regulation, investment funds Cyprus, fund manager license Cyprus "
                url="/funds-asset-management-license-cyprus"
            />

            <IntroSection
                title="Funds & Asset Management License – Cyprus (CySEC)"
                subtitle="Establish Your Fund or Asset Management Firm in the EU"
                description="Cyprus is a competitive EU hub for funds and asset managers, providing a full range of UCITS, Alternative Investment Funds (AIFs), and Professional Investor Funds (PIFs). Regulated by the Cyprus Securities and Exchange Commission (CySEC), these structures enjoy EU recognition, tax advantages, and passporting rights across the EEA. With lower costs than Luxembourg and Ireland, Cyprus is especially attractive for hedge funds, private equity, family offices, and alternative investment managers."
                badges={[
                    "UCITS",
                    "AIF (Alternative Investment Fund)",
                    "AIFM License",
                    "PIF (Professional Investor Fund)"
                ]}
                buttonText="Request a Cyprus Funds Proposal →"
                buttonLink="/quote"
                imageSrc={require("../../../../assets/images/services/funds-asset-management-license-cyprus.png")}
                imageAlt="Cyprus Funds & Asset Management"
            />


            <section className='section'>
                <div className="container">
                    <WhySection
                        title='Why Choose Cyprus for Funds & Asset Management?'
                        blocks={
                            [
                                {
                                    items:
                                        [
                                            {
                                                title: "EU Recognition",
                                                text: "Regulated under AIFMD & UCITS directives."
                                            },
                                            {
                                                title: "CySEC Supervision",
                                                text: "Respected EU regulator ensuring credibility."
                                            },
                                            {
                                                title: "Passporting Rights",
                                                text: "Market funds across the entire EEA."
                                            },
                                            {
                                                title: "Cost Advantage",
                                                text: "Cheaper than Luxembourg & Ireland."
                                            },
                                            {
                                                title: "Attractive Tax Regime",
                                                text: "12.5% corporate tax, 0% on dividend payments."
                                            },
                                            {
                                                title: "Flexible Structures",
                                                text: "PIFs for HNWIs, AIFs for institutions, UCITS for retail."
                                            }
                                        ]
                                }
                            ]
                        }
                    />

                    <InfoBlocks
                        title="Types of Fund & Asset Management Structures in Cyprus"
                        blocks={[
                            {
                                title: "UCITS (Retail Funds)",
                                items: [
                                    { text: "Designed for retail investors." },
                                    { text: "Highly regulated & passportable across the EEA." },
                                    { text: "Covers equities, bonds, mixed funds." },
                                    { text: "Capital Requirement: €125,000–€300,000." }
                                ]
                            },
                            {
                                title: "Alternative Investment Fund (AIF)",
                                items: [
                                    { text: "Flexible structure for professional investors." },
                                    { text: "Covers hedge funds, private equity, venture capital, and real estate funds." },
                                    { text: "Can be marketed across EU under AIFMD." },
                                    { text: "Capital Requirement: €125,000–€300,000." }
                                ]
                            },
                            {
                                title: "Professional Investor Fund (PIF)",
                                items: [
                                    { text: "Cyprus-specific structure for HNWIs & institutions." },
                                    { text: "Lower regulatory burden than UCITS/AIF." },
                                    { text: "Minimum investment: €100,000 per investor." },
                                    { text: "Can be structured as umbrella funds with multiple sub-funds." }
                                ]
                            },
                            {
                                title: "AIFM (Alternative Investment Fund Manager License)",
                                items: [
                                    { text: "Allows management of AIFs including cross-border." },
                                    { text: "Required for funds above certain thresholds (€100M+ with leverage)." }
                                ]
                            }
                        ]}
                    />

                    <LocationTimeline
                        title="Capital & Compliance Requirements"
                        item={
                            [
                                {
                                    title: "UCITS & AIF Managers",
                                    text: "€125,000–€300,000."
                                },
                                {
                                    title: "PIFs",
                                    text: "Lighter compliance regime."
                                },
                                {
                                    title: "Local Presence",
                                    text: "Cyprus entity, resident directors, compliance staff."
                                },
                                {
                                    title: "Ongoing Compliance",
                                    text: "Annual audits, NAV reporting, risk management framework."
                                }
                            ]
                        }
                    />

                    <ServiceCards
                        title='Benefits of a Cyprus Fund License'
                        services={
                            [
                                {
                                    title: "EU Passporting",
                                    text: "Access to all EEA investors."
                                },
                                {
                                    title: "Strong Regulatory Framework",
                                    text: "Aligned with AIFMD & UCITS directives."
                                },
                                {
                                    title: "Flexibility",
                                    text: "Choose between PIF, AIF, UCITS depending on investor type."
                                },
                                {
                                    title: "Cost-Effective EU Entry",
                                    text: "Significantly cheaper than Luxembourg or Ireland."
                                },
                                {
                                    title: "Tax Efficient",
                                    text: "Attractive for family offices and international fund managers."
                                }
                            ]
                        }
                    />

                    <FeatureCards
                        title='Licensing Process'
                        features={
                            [
                                {
                                    title: "Consultation & Planning",
                                    text: "Choose UCITS, AIF, or PIF structure."
                                },
                                {
                                    title: "Entity Incorporation",
                                    text: "Establish fund or company structure in Cyprus."
                                },
                                {
                                    title: "Application Submission",
                                    text: "Prepare business plan, risk policies, and AML/KYC framework."
                                },
                                {
                                    title: "CySEC Review",
                                    text: "Due diligence on managers, governance, and fund strategy."
                                },
                                {
                                    title: "Approval & Licensing",
                                    text: "Typically completed in 6–12 months."
                                }
                            ]
                        }
                    />

                    <TimelineSection
                        title='Timeline & Costs'
                        items={
                            [
                                {
                                    name: "Timeline",
                                    duration: "6–12 months.",
                                },
                                {
                                    name: "Setup Costs",
                                    description: "from €100,000+ (legal, compliance, structuring)."
                                },
                                {
                                    name: "Capital Requirement",
                                    description: "€125,000–€300,000 depending on fund type."
                                },
                                {
                                    name: "Annual Costs",
                                    description: "audits, CySEC supervision, administrators."
                                },

                            ]
                        }
                    />

                    <DetailsSection
                        title='Why Offshore Advisory?'
                        items={
                            [
                                {
                                    text: "Experts in CySEC fund licensing & structuring."
                                },
                                {
                                    text: "Guidance on UCITS, AIF, AIFM, and PIFs."
                                },
                                {
                                    text: "End-to-end service: incorporation, license filing, compliance, administration setup."
                                },
                                {
                                    text: "Introductions to fund administrators, custodians, and auditors."
                                },
                                {
                                    text: "Comparison: Cyprus vs Malta vs Luxembourg vs Offshore."
                                }
                            ]
                        }
                    />

                    <FAQList data={faqData} title='Frequently Asked Questions (FAQ)'/>

                    <Testimonials
                        title="Client Testimonials"
                        testimonials={testimonialsData}
                    />

                    <CTA
                        title="Looking to launch an EU-regulated fund or asset management firm?"
                        description="Cyprus offers UCITS, AIF, and PIF structures under CySEC, combining EU recognition with cost efficiency."
                        buttonText="Book a Cyprus Fund License Consultation →"
                        buttonLink="/quote"
                    />
                </div>
            </section>
        </main>
    );
};

const faqData = [
    {
        question: "Why choose Cyprus for funds over Luxembourg or Ireland?",
        content: [
            { type: "answer", text: "Cyprus is much more cost-efficient while still offering EU recognition and passporting." },
        ],
    },
    {
        question: "What is a PIF?",
        content: [
            { type: "answer", text: "A Professional Investor Fund for HNWIs and institutions — flexible and lightly regulated." },
        ],
    },
    {
        question: "Can Cyprus funds be marketed across the EU?",
        content: [
            { type: "answer", text: "Yes — UCITS and AIFs have EEA passporting rights." },
        ],
    },
    {
        question: "How long does licensing take?",
        content: [
            { type: "answer", text: "Around 6–12 months." },
        ],
    },
    {
        question: "Do Cyprus funds attract global investors?",
        content: [
            { type: "answer", text: "Yes — thanks to EU credibility + low tax, Cyprus funds attract family offices, hedge funds, and private equity." },
        ],
    },
];

const testimonialsData = [
    {
        quote: "Our hedge fund was set up in Cyprus under the AIF regime. Offshore Advisory handled licensing and custodian onboarding.",
        author: "David P.",
        role: "Fund Manager"
    },
    {
        quote: "Cyprus gave us an affordable way to launch a PIF. Offshore Advisory made the process efficient and investor-ready.",
        author: "Sofia K.",
        role: "Asset Management Director"
    }
];
